<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MTL3Sa/tc-custom/9780226821313.jpg?1731838249853" alt="This image is the cover for the book Professing Criticism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Professing Criticism
      </h1>
      <p class="bookDescription body article font2">
        <b>A sociological history of literary study—both as a discipline and as a profession.</b><br/>  <br/> As the humanities in higher education struggle with a labor crisis and with declining enrollments, the travails of literary study are especially profound. No scholar has analyzed the discipline’s contradictions as authoritatively as John Guillory. In this much-anticipated new book, Guillory shows how the study of literature has been organized, both historically and in the modern era, both before and after its professionalization. The traces of this volatile history, he reveals, have solidified into permanent features of the university. Literary study continues to be troubled by the relation between discipline and profession, both in its ambivalence about the literary object and in its anxious embrace of a professionalism that betrays the discipline’s relation to its amateur precursor: criticism. <br/><br/> In a series of timely essays, <i>Professing Criticism</i> offers an incisive explanation for the perennial churn in literary study, the constant revolutionizing of its methods and objects, and the permanent crisis of its professional identification. It closes with a robust outline of five key rationales for literary study, offering a credible account of the aims of the discipline and a reminder to the professoriate of what they already do, and often do well.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Guillory
      </h2>
      
      <p class="authorDescription body article"><B>John Guillory</B> is the Julius Silver Professor of English at New York University. He is coeditor of <I>What’s Left of Theory? New Work on the Politics of Theory</I>&#160;and the author of <I>Cultural Capital: The Problem of Literary Canon Formation</I> and <I>Poetic Authority: Spenser, Milton, and Literary History</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63fd2c16